import GoogleAnalytics from 'lib/GoogleAnalytics';
import eventLogger from 'lib/EventLogger';
import { EventType } from './EventSchema';
import { isSignedIn } from './Auth';
import { updateUser } from './AutolistAPI';
import captureException from './captureException';

interface OptOutValuesInterface {
  ccpaOptOut: boolean;
  isCaResident: boolean;
}

function logOptOutEvent(residency: string): void {
  eventLogger.log({
    event_type: EventType.compliance_engagement,
    engagement_type: 'ccpa_opt_out',
    residency,
  });
  GoogleAnalytics.event({
    category: 'compliance_engagement',
    action: 'ccpa_opt_out',
    label: residency,
    value: undefined,
    nonInteraction: false,
  });
}

async function persistOptOutInfo(isCaResident: boolean): Promise<void> {
  const optOutAttrs = {
    ccpa_opt_out: true,
    state_of_residence: isCaResident ? 'CA' : null,
  };

  if (isSignedIn()) {
    try {
      await updateUser(optOutAttrs);
    } catch (err) {
      captureException(err);
    }
  }
}

const OptOutHelper = {
  setLocalStorageOptOutValues: (isCaResident: boolean): void => {
    window.localStorage.setItem('ccpaOptOut', 'true');
    if (isCaResident) {
      window.localStorage.setItem('isCaResident', 'true');
    }
  },

  getLocalStorageOptOutValues: (): OptOutValuesInterface => {
    const ccpaOptOut = window.localStorage.getItem('ccpaOptOut') === 'true';
    const isCaResident = Boolean(window.localStorage.getItem('isCaResident'));
    return { ccpaOptOut, isCaResident };
  },

  onOptOut: (isCaResident: boolean): void => {
    const residence = isCaResident ? 'CA' : 'Other';
    logOptOutEvent(residence);
    persistOptOutInfo(isCaResident);
    OptOutHelper.setLocalStorageOptOutValues(isCaResident);
  },
};

export default OptOutHelper;
